<template>
  <div>
    <div v-if="!pageLoading">
      <top-card
      current="PaymentSelection"
      :cover-type="coverType"
      :instalments="installments()"
      :free-benefits="this.renewal.batchId.freeBenefits"
      :premiumAmount = "premiumAmount"
      :loading="loading"
      @proceed="proceed(premiumAmount, 100)"
      >
      Full Payment
    </top-card>
    <div class="tw-flex tw-justify-center tw-justify-items-center tw-my-8">
      <back-nav :to="$route.name === 'RenewPolicy' ? 'SwitchCoverReview' : 'BranchSelections'" />
    </div>
      <template>
        <bima-bamba-installments
            v-if="coverType.productCode === 702"
            :cover-type="coverType"
            :installments="installments()"
            :premium-amount="premiumAmount"
            @proceed="proceed"
        />
        <div class="mx-auto tw-px-2 md:tw-px-10 md:tw-py-4 tw-py-6 tw-mt-5 md:tw-mt-10 tw-pb-5 tw-bg-transparent ">
            <div class="tw-px-2 md:tw-px-6">
              <card-title
                class="tw--mt-5"
                icon="mdi-shield-car"
                :is-image="false"
                >Payment Plan</card-title
              >
            </div>
            <div
                class="tw-my-20"
                @click="selectOption('100')"
            >
              <premium-amount
                :premium-amount="premiumAmount"
                :showSelected="true"
                :is-selected="distribution === '100'"
                @makePayment="proceed(premiumAmount, 100)"
              >Full Premium Payment</premium-amount>
            </div>
          <div v-if="coverType.coverTypeId === 120">
          <h3 class="c-gray-text c-title-font tw-font-bold tw-ml-3">You can also pay your premium with installments as follows:</h3>
          <div class="tw-w-full tw-flex tw-flex-col">
            <div class="tw-w-full tw-grid tw-grid-cols-1 tw-justify-center tw-my-2 md:tw-my-4"
            >
              <div :class="['tw-flex tw-w-full tw-items-center tw-flex-wrap tw-justify-center tw-p-10 md:tw-p-5 tw-mt-4 tw-rounded-lg tw-border-4', distribution === '40:30:30'?'tw-shadow-md tw-border-blue-500':'tw-border-gray-300']" @click="selectOption('40:30:30')">
                <div class="tw-w-full tw-justify-end tw-flex">
                  <v-icon class="tw-h-6 tw-m-2" :color="distribution === '40:30:30'?'green':'primary'" large>{{ distribution === '40:30:30' ? "mdi-check-circle" : "mdi-circle-outline" }}</v-icon>
                </div>
                <div class="tw-flex tw-flex-col tw-px-2  c-title tw-font-bold c-blue-text tw-items-left tw-align-center tw-justify-start tw-border-0 md:tw-border-r tw-my-4 md:tw-my-0">
                  <h1 class="tw-text-3xl">{{ "40 % 30 % 30 %" }}</h1>
                  <p class="tw-text-lg">Payment Plan</p>
                </div>
                <div v-if="distribution === '40:30:30'" class="tw-flex tw-flex-col md:tw-flex-row">
                  <div class="tw-flex tw-flex-col c-title-font tw-px-4 tw-border-0 md:tw-border-r tw-my-4 md:tw-my-0">
                    <div>
                      <h1 class="tw-text-base tw-font-bold c-blue-text">Subsequent Payments:</h1>
                      <p class="tw-text-lg">{{ installments()[1].dueDate }} : <span class="tw-font-bold">Ksh. {{ installments()[1].premium | formatNum }}</span></p>
                    </div>
                    <div>
                      <h1 class="tw-text-base tw-font-bold c-blue-text">Subsequent Payments:</h1>
                      <p class="tw-text-lg">{{ installments()[2].dueDate }} : <span class="tw-font-bold">Ksh. {{ installments()[2].premium | formatNum }}</span></p>
                    </div>
                  </div>
                  <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                    <h4 class="c-blue-text tw-font-bold tw-text-sm">Premium to pay: {{ "1st Instalment" }}</h4>
                    <h3 class="c-gray-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ installments()[0].premium | formatNum }}</h3>
                  </div>
                </div>
              </div>
              <div :class="['tw-flex tw-w-full tw-items-center tw-flex-wrap tw-justify-center tw-p-10 md:tw-p-5 tw-mt-4 tw-rounded-lg tw-border-4', distribution === '40:60'?'tw-shadow-md tw-border-blue-500':'tw-border-gray-300']" @click="selectOption('40:60')">
                <div class="tw-w-full tw-justify-end tw-flex">
                  <v-icon class="tw-h-6 tw-m-2" :color="distribution === '40:60'?'green':'primary'" large>{{ distribution === '40:60' ? "mdi-check-circle" : "mdi-circle-outline" }}</v-icon>
                </div>
                <div class="tw-flex tw-flex-col tw-px-2  c-title tw-font-bold c-blue-text tw-items-left tw-align-center tw-justify-start tw-border-0 md:tw-border-r tw-my-4 md:tw-my-0">
                  <h1 class="tw-text-3xl">{{ "40 % 60 %" }}</h1>
                  <p class="tw-text-lg">Payment Plan</p>
                </div>
                <div v-if="distribution === '40:60'"  class="tw-flex tw-flex-col md:tw-flex-row">
                  <div class="tw-flex tw-flex-col c-title-font tw-px-4 tw-border-0 md:tw-border-r tw-my-4 md:tw-my-0">
                    <div>
                      <h1 class="tw-text-base tw-font-bold c-blue-text">Subsequent Payments:</h1>
                      <p class="tw-text-lg">{{ installments()[1].dueDate }} : <span class="tw-font-bold">Ksh. {{ installments()[1].premium | formatNum }}</span></p>
                    </div>
                  </div>
                  <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
                    <h4 class="c-blue-text tw-font-bold tw-text-sm">Premium to pay: {{ "1st Instalment" }}</h4>
                    <h3 class="c-gray-text title-font tw-text-4xl md:tw-text-5xl">Kshs. {{ installments()[0].premium | formatNum }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="tw-flex tw-justify-center tw-w-full">
            <v-btn class="tw-m-10 tw-p-10 tw-rounded-none tw-normal-case c-title tw-text-lg" @click="proceed()" color="primary">
              Select Valuer
            </v-btn>
          </div>
      </div>
      </template>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import BackNav from '@/components/buy/BackNav';
import helpers from '@/utils/helpers';
import { addMonths } from '@/utils/time';
import BimaBambaInstallments from '@/components/buy/BimaBambaInstallments';
import TopCard from '@/components/renew/TopCard';
import PremiumAmount from '@/components/buy/PremiumAmount';
import { mapGetters } from 'vuex';
import renewalMixin from '@/mixins/renewalMixin';
import axios from 'axios';
import { FB_BUY_FULL_PAYMENT, FB_BUY_INSTALMENT_PAYMENT } from '@/utils/const';
import CardTitle from '../CardTitle';

export default {
  name: 'PaymentSelection',
  props: {
    renewal: {
      type: Object,
    },
  },
  components: {
    TopCard,
    BimaBambaInstallments,
    BackNav,
    PremiumAmount,
    CardTitle,
  },
  data() {
    return {
      loading: false,
      loading1: false,
      pageLoading: false,
      distribution: '100',
    };
  },
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    pageTitle() {
      if (this.coverType.covertypeId === 120) {
        return `${this.coverType.productCode === 702 ? 'Bima Bamba' : 'Comprehensive'}<br> Insurance Cover`;
      }
      return 'Third Party <br> Only';
    },
    premiumAmount() {
      return this.renewal.batchId.premiumAfterTax;
    },
  },
  metaInfo: {
    title: 'Buy - Payment Selection',
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  mixins: [renewalMixin],
  methods: {
    proceed() {
      this.$analytics.logEvent(this.distribution === '100' ? FB_BUY_FULL_PAYMENT : FB_BUY_INSTALMENT_PAYMENT);
      this.renewal.batchId.distribution = this.distribution;
      this.renewal.premiumInstalments = this.installments();
      localStorage.setItem('distribution', this.distribution);
      this.$emit('to-valuer-selection', this.renewal);
    },
    addMonths,
    selectOption(distribution) {
      this.pageLoading = true;
      const payload = JSON.parse(
        localStorage.getItem('renewalData') || '{}',
      );
      payload.distribution = distribution;
      axios
        .post('/motor/api/policy/renewal', payload)
        .then((response) => {
          this.renewal.batchId = response.data.data;
          payload.premiumAfterTax = response.data.data.premiumAfterTax;
          payload.premiumInstalments = response.data.data.premiumInstalments || [];
          payload.freeBenefits = response.data.data.freeBenefits || [];
          localStorage.setItem('renewalData', JSON.stringify(payload));
          this.distribution = distribution;
          this.pageLoading = false;
        });
    },
    installments() {
      return this.renewal.batchId.premiumInstalments;
    },
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
